<template>

  <el-upload :on-exceed="exceed" :limit=1 class="upload-demo" drag action="#" :http-request="fnUploadRequest" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
    <div class="el-upload__tip" slot="tip">仅支持.xlsx,.xls,.csv等格式文件，且不超过4M</div>
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
  </el-upload>
</template>

<script>
import { isSuccess } from "@/assets/js/utils"
export default {
  data () {
    return {
      fileUrl: '',
    }
  },
  props: {
    image: {
      _title: '',
      _required: false,
      _disabled: false,
      image_url: null,
    }
  },
  created () {
  },
  methods: {
    handleAvatarSuccess (res, file) {
      this.fileUrl = URL.createObjectURL(file.raw);
      //   console.log(this.fileUrl)
    },
    exceed (file, fileList) {
      this.$message.error('上传文件不能2个!');
    },
    beforeAvatarUpload (file) {
      const TYPE1 = file.name.split('.')[1] === 'xlsx';
      const TYPE2 = file.name.split('.')[1] === 'xls';
      const TYPE3 = file.name.split('.')[1] === 'csv';
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!TYPE1 && !TYPE2 && !TYPE3) {
        this.$message.error('仅支持.xlsx,.xls,.csv等格式文件!');
      }
      if (!isLt4M) {
        this.$message.error('文件不能超过 4MB!');
      }
      return ((TYPE1 || TYPE2 || TYPE3) && isLt4M);
    },
    async fnUploadRequest (option) {
      this.api(100999, {}).then(res => {
        let data
        if (data = this.utils.isSuccess(res)) {
          let OSS = require('ali-oss');
          let store = new OSS({
            region: data.aliyun_region,
            accessKeyId: data.access_key_id,
            accessKeySecret: data.access_key_secret,
            stsToken: data.security_token,
            bucket: data.aliyun_bucket
          });
          let random_name = this.guid() + '.' + option.file.name.split('.').pop()
          store.put(random_name, option.file).then(res => {
            let url = res.url.replace(/static-5j56-com.oss-cn-shanghai.aliyuncs.com/, "static.5j56.com")
            this.$emit('getUrl', url)
          })
        }
      })
    },
    guid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
  }
}
</script>

<style scoped lang="scss">
.el-upload__tip {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-excel.vue